import React from 'react';
import { Menu, Dropdown, Icon } from 'antd';
import { DropDownSpan, StyledMenuItem, StyledSubMenu } from '../styled';

const BookingDropdown = ({ authUser, booking, createBooking, openFixter, openPopup, overlaysMenu }) => {
  const handleMenuClick = (menu) => {
    if (!menu.popup) return;

    switch (menu.popup) {
      case 'CreateBooking':
        createBooking({
          userId: authUser.username,
          bookingId: booking.bookingId,
          utmMedium: menu.utm_medium,
          utmSource: menu.utm_source,
          utmCampaign: menu.utm_campaign,
        });
        break;
      case 'OpenFixter':
        openFixter({
          userId: authUser.username,
          bookingId: booking.bookingId,
        });
        break;
      default:
        openPopup(menu.popup);
    }
  };

  const renderMenuItem = (item) => {
    const className = item.text.includes('Create') ? 'create-booking-link' : '';
    const dataDivider = item.text === 'Create Phone sales booking';

    if (item.subMenuItems) {
      return (
        <StyledSubMenu key={item.key} title={item.text} className={className}>
          {item.subMenuItems.map((subItem) => renderMenuItem(subItem))}
        </StyledSubMenu>
      );
    }

    return (
      <StyledMenuItem
        key={item.key}
        onClick={() => handleMenuClick(item)}
        className={className}
        data-divider={dataDivider}
      >
        {item.text}
      </StyledMenuItem>
    );
  };

  return (
    <Dropdown
      overlay={<Menu>{overlaysMenu.map((menuItem) => renderMenuItem(menuItem))}</Menu>}
      placement="bottomRight"
      trigger={['click']}
    >
      <DropDownSpan data-testid="dropdown-trigger">
        <Icon type="down-circle" theme="filled" />
      </DropDownSpan>
    </Dropdown>
  );
};

export default BookingDropdown;
